/* lib/PostcodeLookup/Input.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	stop_propagation,
	text,
	validate_slots
} from "svelte/internal";

const file = "lib/PostcodeLookup/Input.svelte";

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let label_class_value;
	let t1;
	let input;
	let input_class_value;
	let t2;
	let button;
	let t3;
	let button_class_value;
	let div_class_value;
	let dispose;

	const block = {
		c: function create() {
			div = element("div");
			label = element("label");
			t0 = text("Postcode Lookup");
			t1 = space();
			input = element("input");
			t2 = space();
			button = element("button");
			t3 = text("Lookup");
			attr_dev(label, "class", label_class_value = /*classNames*/ ctx[1].label);
			attr_dev(label, "for", "postcode-lookup-input");
			add_location(label, file, 11, 2, 220);
			attr_dev(input, "id", "postcode-lookup-input");
			attr_dev(input, "class", input_class_value = /*classNames*/ ctx[1].text);
			attr_dev(input, "placeholder", "Enter your postcode");
			attr_dev(input, "type", "text");
			add_location(input, file, 14, 2, 314);
			attr_dev(button, "class", button_class_value = /*classNames*/ ctx[1].button);
			attr_dev(button, "type", "submit");
			add_location(button, file, 15, 2, 442);
			attr_dev(div, "data-testid", "container");
			attr_dev(div, "class", div_class_value = /*classNames*/ ctx[1].container);
			add_location(div, file, 10, 0, 159);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor, remount) {
			insert_dev(target, div, anchor);
			append_dev(div, label);
			append_dev(label, t0);
			append_dev(div, t1);
			append_dev(div, input);
			set_input_value(input, /*value*/ ctx[0]);
			append_dev(div, t2);
			append_dev(div, button);
			append_dev(button, t3);
			if (remount) run_all(dispose);

			dispose = [
				listen_dev(input, "input", /*input_input_handler*/ ctx[4]),
				listen_dev(button, "click", stop_propagation(prevent_default(/*handleClick*/ ctx[2])), false, true, true)
			];
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*classNames*/ 2 && label_class_value !== (label_class_value = /*classNames*/ ctx[1].label)) {
				attr_dev(label, "class", label_class_value);
			}

			if (dirty & /*classNames*/ 2 && input_class_value !== (input_class_value = /*classNames*/ ctx[1].text)) {
				attr_dev(input, "class", input_class_value);
			}

			if (dirty & /*value*/ 1 && input.value !== /*value*/ ctx[0]) {
				set_input_value(input, /*value*/ ctx[0]);
			}

			if (dirty & /*classNames*/ 2 && button_class_value !== (button_class_value = /*classNames*/ ctx[1].button)) {
				attr_dev(button, "class", button_class_value);
			}

			if (dirty & /*classNames*/ 2 && div_class_value !== (div_class_value = /*classNames*/ ctx[1].container)) {
				attr_dev(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { value = "" } = $$props;
	let { classNames = {} } = $$props;
	let { onLookup = () => null } = $$props;
	const handleClick = () => onLookup(value);
	const writable_props = ["value", "classNames", "onLookup"];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== "$$") console.warn(`<Input> was created with unknown prop '${key}'`);
	});

	let { $$slots = {}, $$scope } = $$props;
	validate_slots("Input", $$slots, []);

	function input_input_handler() {
		value = this.value;
		$$invalidate(0, value);
	}

	$$self.$set = $$props => {
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onLookup" in $$props) $$invalidate(3, onLookup = $$props.onLookup);
	};

	$$self.$capture_state = () => ({ value, classNames, onLookup, handleClick });

	$$self.$inject_state = $$props => {
		if ("value" in $$props) $$invalidate(0, value = $$props.value);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onLookup" in $$props) $$invalidate(3, onLookup = $$props.onLookup);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [value, classNames, handleClick, onLookup, input_input_handler];
}

class Input extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { value: 0, classNames: 1, onLookup: 3 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Input",
			options,
			id: create_fragment.name
		});
	}

	get value() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set value(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get classNames() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set classNames(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get onLookup() {
		throw new Error("<Input>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set onLookup(value) {
		throw new Error("<Input>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Input;